import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { PositionSummary } from '../../../models/positions.model';

@Component({
	selector: 'app-position-modal',
	styles: [
		`
			.item {
				height: 40px;
				border: 1px solid #d9d9d9;
				&:hover {
					background-color: #f0f0f0;
				}
			}
			.gray {
				color: #626262;
			}
			.separator {
				width: calc(100% - 32px);
				height: 1px;
				margin: 16px 0 16px 16px;
				background-color: #d9d9d9;
			}
			.mb-fix {
				margin-bottom: 84px;
			}
			@media only screen and (max-width: 768px) {
				/* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
				:host::ng-deep.mat-checkbox-layout {
					white-space: normal !important;
				}
				/* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
				:host::ng-deep.mat-checkbox-inner-container {
					margin-top: 4px;
				}
			}
		`,
	],
	templateUrl: './position-modal.component.html',
})
export class PositionModalComponent implements OnInit {
	resultIds: string[] = [];

	constructor(
		public dialogRef: MatDialogRef<PositionModalComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: { positions: PositionSummary[]; selected: string[] },
	) {}

	closeModal() {
		this.dialogRef.close();
	}

	masterSelection(): boolean {
		return this.resultIds.length === this.data.positions.length;
	}

	ngOnInit(): void {
		this.resultIds = this.data.selected;
	}

	onMasterToggle(): void {
		if (this.masterSelection()) {
			this.resultIds = [];
		} else {
			const all = this.data.positions.map((p) => p.id);
			this.resultIds = all;
		}
	}

	onPositionToggle(id: string, checked: boolean): void {
		if (!checked) {
			this.resultIds.splice(
				this.resultIds.findIndex((i) => id === i),
				1,
			);
		} else {
			this.resultIds.push(id);
		}
	}

	positionLabel(idx: number): string {
		const wage =
			this.data.positions[idx].min_wage || this.data.positions[idx].max_wage
				? ` / ${
						this.data.positions[idx].min_wage
							? `R$${this.data.positions[idx].min_wage}`
							: ''
					}${
						this.data.positions[idx].max_wage
							? `-R$${this.data.positions[idx].max_wage}`
							: ''
					}`
				: '';
		const location = this.data.positions[idx].state
			? ` / ${
					this.data.positions[idx].city
						? `${this.data.positions[idx].city} - `
						: ''
				}${this.data.positions[idx].state}`
			: '';

		return `${wage}${location}`;
	}

	savePositions(): void {
		const result = this.data.positions.filter((p) =>
			this.resultIds.includes(p.id),
		);
		this.dialogRef.close(result);
	}
}
